<div class="login-assistant-page-container">
  <div class="header-red">
    <span class="d-inline-block text-truncate header-text" id="school-name">{{organisationName}}</span>
  </div>

  <div class="group-tile-container">
    <div id="group-list-container" class="tiles-wrapper">
      <au-tile *ngIf="showBackToSchoolsTile" [tile]="backTile" (onClick)="goBack()"></au-tile>
      <au-tile *ngIf="hasGroupWithQrLogin" [tile]="qrGroupTile" (onClick)="openQrLogin('QrTile')"></au-tile>
      <au-tile [tile]="personnelTile" (onClick)="openPersonnel()"></au-tile>
      <au-tile *ngFor="let group of groupTiles" [tile]="group" (onClick)="openGroup(group)"> </au-tile>
    </div>
  </div>
</div>
